import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useForceChangePassword = (id) => {
  const mutationFn = () => client.users.forceChangePassword(id);

  return useMutation({
    mutationFn,
  });
};
